import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import { MosaicDispatch } from "./middleware";
import { useDispatch } from "react-redux";

export type AppDispatch = MosaicDispatch & ThunkDispatch<any, any, AnyAction>;

export function useAppDispatch() {
  return useDispatch<AppDispatch>();
}
